import { render, staticRenderFns } from "./liveorder.vue?vue&type=template&id=0d45a013&scoped=true"
import script from "./liveorder.vue?vue&type=script&lang=js"
export * from "./liveorder.vue?vue&type=script&lang=js"
import style0 from "./liveorder.vue?vue&type=style&index=0&id=0d45a013&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45a013",
  null
  
)

export default component.exports